exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".dropzone .dz-error[data-v-28f4d41e]{border:2px solid red}.dropzone .dz-error-message[data-v-28f4d41e]{opacity:1}", ""]);


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-28f4d41e","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/partials/dropzone.vue
// module id = 400
// module chunks = 0